/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import type { StyleXStyles } from '@stylexjs/stylex';

/**
 * Merges StyleX styles into a single list, normalizing numeric-keyed objects produced by React Aria context merges.
 */
export function mergeStyles(...styles: StyleXStyles[]) {
  return styles.flatMap((style) => {
    if (!style) {
      return [];
    }

    return Array.isArray(style) ? (style as StyleXStyles[]) : [style];
  });
}
